

<ng-container>
  <div
    class="custom-answer__group form-group mb-0"
    [ngClass]="isPercentage ? 'custom-answer__group--percent' : 'custom-answer__group--value'"
    [id]="uniqueId">
    @for (item of childrenQuestions; track item; let i = $index) {
      <app-question-controller
        [question]="item"
        [showLabel]="showLabel"
        [controlCssClass]="' '"
        [useUiFront]="false"
        (questionAnswer)="onChange($event, i)">
      </app-question-controller>
    }
  </div>
</ng-container>
